<!-- eslint-disable no-trailing-spaces -->
<!-- eslint-disable dot-notation -->
<template>
    <div class="d-flex main-container">
      <!-- Side Menu -->
      <!-- In your main component template, replace the side menu section with: -->
       <div class="side-nav">
          <side-menu 
            :active-item="activeMenu" 
            @menu-change="handleMenuChange"
          />
      </div>
  
      
      <!-- Main Content -->
      <div class="main-content">
        <b-container class="touchpoint-dashboard">
          <b-card class="dashboard-card content-card">
      
            <b-card-body>
              <!-- Sales Info -->
              <div class="row sales-info" name="data-squares">
                <div class="col-xl-4 col-lg-6 col-12 mb-3">
                  <div class="data-square mb-3">
                    <div class="p-3 d-flex flex-column min-h-100">
                      <!-- Date Range -->
                      <div class="flex row justify-content-between pr-3 pl-3">
                        <h5 class="mb-3">Filter</h5>

                        <div>
                          <b-button 
                            @click="subtractDay"
                            variant="light"
                            style="background-color: dimgray; height: 2em; font-weight: bolder;"
                            class="b-flex justify-content-between align-items-center">
                            <font-awesome-icon style="height: 100%; width: 100%;" :icon="icons.faAngleLeft" class="text-white"/>
                          </b-button>
                          
                          <b-button 
                            @click="addDay"
                            variant="light"
                            style="background-color: dimgray; height: 2em; font-weight: bolder;"
                            class="b-flex justify-content-between align-items-center">
                            <font-awesome-icon style="height: 100%; width: 100%;" :icon="icons.faAngleRight" class="text-white"/>
                          </b-button>
                        </div>

                      </div>
                      <div>
                        <label for="date-range-picker" class="font-weight-bold d-block mb-2 text-muted"><h6>Date Range:</h6></label>
                        <b-input-group class="d-flex flex-row gap-2">
                          <b-form-datepicker 
                            id="start-date-picker" 
                            :date-format-options="{ year: 'numeric', month: '2-digit', day: 'numeric', weekday: 'long' }"
                            nav-button-variant="dark"
                            selected-variant="secondary"
                            v-model="filters.startDate"
                            :max="filters.endDate"
                            class="w-50"
                          ></b-form-datepicker>
                          <b-form-datepicker 
                            id="end-date-picker" 
                            :date-format-options="{ year: 'numeric', month: '2-digit', day: 'numeric', weekday: 'long' }"
                            nav-button-variant="dark"
                            selected-variant="secondary"
                            v-model="filters.endDate"
                            :min="filters.startDate"
                            class="w-50"
                          ></b-form-datepicker>
                        </b-input-group>
                      </div>
  
                      <!-- Go Button - Using mt-auto to push to bottom and flex-grow for spacing -->
                      <div class="mt-auto pt-3">
                        <b-button 
                          variant="success"
                          class="w-100"
                          @click="fetchData" 
                          :disabled="loading"
                          size="md"
                        >
                          <i class="fas fa-sync-alt me-2"></i>
                          {{ loading ? 'Loading...' : 'Fetch Data' }}
                        </b-button>
                      </div>
                    </div>
                  </div>

                <div class="side-search" id="my-search">
                    <!-- <h5>Search</h5> -->
                    <b-form-input class="my-search" v-model="filters.search" placeholder="Search..."></b-form-input>
                </div>
                    
                </div>
                
                <div class="col-xl-8 col-lg-6 col-12 mb-3">
                  <div class="sales-data">
                    <div class="p-3 h-100">
                      <h5 class="mb-3">Sales Overview</h5>
                      <b-button 
                        @click="exportToCSV"
                        variant="dark"
                        style="top: 1em; right: 1em; width: 5em; height: 2em; font-weight: bolder;"
                        class="position-absolute d-flex justify-content-between align-items-center px-2">
                        CSV
                        <font-awesome-icon :icon="icons.faDownload" class="text-white"/>
                      </b-button>
                        
                      <!-- Origin Breakdown -->
                      <div  class="mb-2">
                        <!-- <h6 class="text-muted mb-2">Total Sales by Source</h6> -->
                        <div class="text-center origin-group">

                          <div class="card-group">
                          <div class="origin-card p-2 bg-warning text-white">
                              <b>Total Sales</b>
                              <div class="h6 mb-0 font-weight-bold">
                              ${{ originTotals.totalSales.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                              </div>
                          </div>
                          <div class="origin-card p-2 bg-primary text-white">
                            <b>In Store</b>
                            <div class="h6 mb-0 font-weight-bold">
                              ${{ originTotals.inStore.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                            </div>
                          </div>
                          <div class="origin-card p-2 bg-success text-white">
                            <b>Online</b>
                            <div class="h6 mb-0 font-weight-bold">
                              ${{ originTotals.chickenShackApp.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                            </div>
                          </div>

                          </div>

                          <div class="card-group">
                            <div class="origin-card p-2 bg-info text-white">
                                <b>Doordash</b>
                                <div class="h6 mb-0 font-weight-bold">
                                ${{ originTotals.doordash.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                </div>
                            </div>
                            <div class="origin-card p-2 bg-uber text-white">
                                <b>Uber</b>
                                <div class="h6 mb-0 font-weight-bold">
                                ${{ originTotals.uber.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                </div>
                            </div>
                            <div class="origin-card p-2 bg-grubhub-alt text-white">
                                <b>Grubhub</b>
                                <div class="h6 mb-0 font-weight-bold">
                                ${{ originTotals.grubhub.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                </div>
                            </div>
                            <div class="origin-card p-2 bg-blank text-white" :style="{ display: originTotals.blank === 0 ? 'none' : 'block' }">
                                <b>Unknown</b>
                                <div class="h6 mb-0 font-weight-bold">
                                ${{ originTotals.blank.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Top Performing Store -->
                      <div class="d-flex flex-row justify-content-between">
                        <div class="w-50 mr-2">
                            <h6 class="text-muted mb-1">Top Performing Store</h6>
                            <div class="top-store-card p-1 bg-light rounded">
                            <div v-if="topStore" class="d-flex align-items-center">
                                <div class="store-icon me-3">
                                <i class="fas fa-trophy text-warning fa-2x"></i>
                                </div>
                                <div class="store-info">
                                    <strong class="h6 mb-1">{{ topStore.Location }}</strong>
                                    <div class="text-success">
                                        <strong>${{ topStore.Total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</strong>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="text-center text-muted">
                                <p>No data available</p>
                            </div>
                            </div>
                        </div>

                        <div class="w-50 mr-2">
                            <h6 class="text-muted mb-1">Worst Performing Store</h6>
                            <div class="worst-store-card p-1 bg-light rounded">
                                <div v-if="worstStore" class="d-flex align-items-center">
                                    <div class="store-icon me-3">
                                    <i class="fas fa-trophy text-warning fa-2x"></i>
                                    </div>
                                    <div class="store-info">
                                    <strong class="h6 mb-1">{{ worstStore.Location }}</strong>
                                    <div class="text-danger">
                                        <strong>${{ worstStore.Total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</strong>
                                    </div>
                                    </div>
                                </div>
                                <div v-else class="text-center text-muted">
                                    <p>No data available</p>
                                </div>
                            </div>
                        </div>
                      </div>                      
                    </div>
                  </div>
                </div>
              </div>

              <!-- Sales Table -->
              <b-table
                striped
                hover
                :items="filteredData"
                :fields="fields"
                :filter="filters.search"
                sort-by="Location"
                :busy="loading"
                show-empty
                responsive
                class="sales-table"
                >
                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
  
                <template #empty>
                  <div class="text-center text-muted">
                    <h4>No data available</h4>
                    <p>Try refreshing the page or check your connection</p>
                  </div>
                </template>
  
                <!-- Format Origin with custom display values -->
                <!-- Format currency for all sales columns -->
                <template #cell(In_Store)="data">
                ${{ (data.value || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                </template>

                <template #cell(Chicken_Shack_App)="data">
                ${{ (data.value || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                </template>

                <template #cell(Uber)="data">
                ${{ (data.value || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                </template>

                <template #cell(Doordash)="data">
                ${{ (data.value || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                </template>

                <template #cell(Grubhub)="data">
                ${{ (data.value || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                </template>

                <template #cell(BLANK)="data">
                ${{ (data.value || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                </template>

                <template #cell(Total_Sales)="data">
                ${{ (data.value || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                </template>

              </b-table>
  
              <div class="d-flex justify-content-between align-items-center mt-3">
                <div>
                  <strong>Total Records:</strong> {{ filteredData.length }}
                </div>
              </div>
            </b-card-body>
          </b-card>
        </b-container>
      </div>
    </div>
  </template>
  
  <!-- eslint-disable no-trailing-spaces -->
  <script>
  import { DateTime } from "luxon";
  import AuthMixin from "../../mixins/auth.mixin";
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
  import SideMenu from '@/components/admin-nav.vue';
  import { Api } from "shared/api";
  import { apiHandler } from "@/services/api-handler";
  
  import { 
  faDollarSign, 
  faTruck, 
  faBicycle, 
  faStore, 
  faSyncAlt,
  faTrash,
  faCheckCircle,
  faChartLine,
  faExclamationTriangle,
  faDownload,
  faAngleRight,
  faAngleLeft
  } from '@fortawesome/free-solid-svg-icons';
  // Remove the direct service import and use your existing API pattern

  
  export default {
  name: 'tp-sales',
  mixins: [AuthMixin],
  components: {
    SideMenu,
    FontAwesomeIcon
  },
  data() {
    const now = DateTime.now().setZone('America/New_York');
    // const firstDay = now.minus({ months: 1 });
    // const lastDay = now.minus({ months: 1 }).plus({ days: 6 });
    const firstDay = now.startOf('month');  // First day of last month
    const lastDay = firstDay;  // Same as firstDay for single day query
    
    // Helper function to format date
    const formatDate = (date) => {
        return date.toFormat('yyyy-MM-dd');
    };
  
    return {
      loading: false,
      connectionTested: false,
      connectionError: null,
      tableData: [],
      activeMenu: 'Sales',
      filters: {
            startDate: formatDate(firstDay),
            endDate: formatDate(lastDay),
            location: null,
            query: 'Menu Item Matrix'    ,
            search: ''       
        },
        queryOptions: [ 'Menu Item Matrix' ],
        fields: [
        {
          key: 'Location',
          label: 'Location',
          sortable: true,
          class: 'text-left',
          thStyle: { width: '20%' }
        },
        {
          key: 'Order_Count',
          label: 'Orders',
          sortable: true,
          class: 'text-left',
          thStyle: { width: '5%' }
        },
        {
          key: 'In_Store',
          label: 'In Store',
          sortable: true,
          class: 'text-right',
          thStyle: { width: '10%' }
        },
        {
          key: 'Chicken_Shack_App',
          label: 'Online',
          sortable: true,
          class: 'text-right',
          thStyle: { width: '10%' }
        },
        {
          key: 'Doordash',
          label: 'Doordash',
          sortable: true,
          class: 'text-right',
          thStyle: { width: '10%' }
        },
        {
          key: 'Uber',
          label: 'Uber',
          sortable: true,
          class: 'text-right',
          thStyle: { width: '10%' }
        },
        {
          key: 'Grubhub',
          label: 'Grubhub',
          sortable: true,
          class: 'text-right',
          thStyle: { width: '10%' }
        },
        {
          key: 'BLANK',
          label: 'Unknown',
          sortable: true,
          class: 'text-right',
          thStyle: { width: '10%' }
        },
        {
          key: 'Total_Sales',
          label: 'Sales ($)',
          sortable: true,
          class: 'text-right',
          thStyle: { width: '10%' }
        }
      ],
      icons: {
        faDollarSign,
        faTruck, 
        faBicycle, 
        faStore, 
        faSyncAlt,
        faTrash,
        faCheckCircle,
        faExclamationTriangle,
        faChartLine,
        faDownload,
        faAngleRight,
        faAngleLeft
      },
    };
  },
  computed: {
    // Get filtered data based on search
    filteredData() {
        if (!this.filters.search) {
        return this.tableData;
        }
        
        const searchTerm = this.filters.search.toLowerCase();
        return this.tableData.filter(item => {
        const location = item.Location ? item.Location.toLowerCase() : '';
        const inStore = item['In Store'] ? item['In Store'].toString() : '';
        const chickenShackApp = item['Chicken Shack App'] ? item['Chicken Shack App'].toString() : '';
        const mobileApp = item['Mobile App'] ? item['Mobile App'].toString() : '';
        const totalSales = item['Total Sales'] ? item['Total Sales'].toString() : '';
        
        return (
            location.includes(searchTerm) ||
            inStore.includes(searchTerm) ||
            chickenShackApp.includes(searchTerm) ||
            mobileApp.includes(searchTerm) ||
            totalSales.includes(searchTerm)
        );
        });
    },

    // Top performing store by total sales - UPDATED for new columns
    topStore() {
        if (!this.filteredData.length) return null;
        
        const salesByLocation = {};
        this.filteredData.forEach(item => {
            salesByLocation[item.Location] = (salesByLocation[item.Location] || 0) + (item.Total_Sales || 0);
        });
        
        const top = Object.entries(salesByLocation).reduce((a, b) => a[1] > b[1] ? a : b);
        return { Location: top[0], Total: top[1] };
    },

        // Top performing store by total sales - UPDATED for new columns
    worstStore() {
        if (!this.filteredData.length) return null;
        
        const salesByLocation = {};
        this.filteredData.forEach(item => {
            salesByLocation[item.Location] = (salesByLocation[item.Location] || 0) + (item.Total_Sales || 0);
        });
        
        const top = Object.entries(salesByLocation).reduce((a, b) => a[1] < b[1] ? a : b);
        return { Location: top[0], Total: top[1] };
    },
    
    // Sum of origin data types - UPDATED for new columns
    originTotals() {
        const totals = {
        inStore: 0,
        chickenShackApp: 0,
        mobileDelivery: 0,
        doordash: 0,
        uber: 0,
        grubhub: 0,
        blank: 0,
        totalSales: 0
        };
        
        this.filteredData.forEach(item => {
        // Sum each origin type
        totals.inStore += item.In_Store || 0;
        totals.chickenShackApp += item.Chicken_Shack_App || 0;
        // totals.mobileDelivery += item.Mobile_App || 0;
        totals.doordash += item.Doordash || 0;
        totals.uber += item.Uber || 0;
        totals.grubhub += item.Grubhub || 0;
        totals.blank += item.BLANK || 0;
        totals.totalSales += item.Total_Sales || 0;
        });
        
        return totals;
    },
    
    // Total sales across all locations and origins - UPDATED for new columns
    totalSales() {
        return this.filteredData.reduce((sum, item) => sum + (item.Total_Sales || 0), 0);
    },
    
    // Unique locations
    uniqueLocations() {
        const locations = new Set();
        this.filteredData.forEach(item => locations.add(item.Location));
        return Array.from(locations);
    }
    },
  async mounted() {
      try {
          await this.fetchData();
      } catch (error) {
        console.error('❌ Connection failed:', error);
      }
    },
  methods: {
    getLocationNumber(location) {
      const mappings = {
        'Royal Oak- 11 Mile	': '1',
        'Royal Oak-Woodward': '2', 
        'Warren-Ryan': '3',
        'Warren- Schoenherr	': '4',
        'New Baltimore': '5',
        'Grosse Pointe': '6',
        'St. Clair Shores': '7',
        'Lincoln Park': '8',
        'Sterling Heights- Van Dyke': '9',
        'Westland': '10',
        'Macomb Township': '11',
        'Rochester': '12',
        'Detroit': '13',
        'Clarkson': '14',
        'Clawson': '15',
        'Southfield': '16',
        'Livonia': '17',
        'Riverview': '18',
        'Clinton Township': '19',
        'Shelby Township': '20',
        'Brownstown': '21',
        'Bloomfield Township': '22',
        'Ypsilanti': '23',
        'Grand Blanc': '24',
        'Sterling Heights-18 Mile': '25',
        'Oxford': '26'
      };
      
      // Find matching location
      for (const [key, value] of Object.entries(mappings)) {
        if (location.includes(key) || key.includes(location)) {
          return value;
        }
      }
      
      return null;
    },
    addDay() {
      const startDate = DateTime.fromISO(this.filters.startDate);
      const endDate = DateTime.fromISO(this.filters.endDate);
      
      this.filters.startDate = startDate.plus({ days: 1 }).toFormat('yyyy-MM-dd');
      this.filters.endDate = endDate.plus({ days: 1 }).toFormat('yyyy-MM-dd');
    },
    subtractDay() {
      const startDate = DateTime.fromISO(this.filters.startDate);
      const endDate = DateTime.fromISO(this.filters.endDate);
      
      this.filters.startDate = startDate.minus({ days: 1 }).toFormat('yyyy-MM-dd');
      this.filters.endDate = endDate.minus({ days: 1 }).toFormat('yyyy-MM-dd');
    },
    exportToCSV() {
      if (!this.filteredData.length) {
        this.$bvToast.toast('No data to export', {
          title: 'Export Error',
          variant: 'warning',
          solid: true
        });
        return;
      }

      try {
        // Use your table fields for headers and column order
        const headers = this.fields.map(field => field.label);
        const keys = this.fields.map(field => field.key);
        
        // Create CSV content
        let csvContent = headers.join(',') + '\n';
        
        // Add rows
        this.filteredData.forEach(item => {
          const row = keys.map(key => {
            const value = item[key] || '';
            
            // Handle different data types
            if (value === null || value === undefined) {
              return '';
            }
            
            // Format numbers (remove currency formatting for CSV)
            if (typeof value === 'number') {
              // Format to 2 decimal places
              return value.toFixed(2);
            }
            
            // Handle strings that might contain commas or quotes
            const stringValue = String(value);
            if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
              // Escape quotes and wrap in quotes
              return `"${stringValue.replace(/"/g, '""')}"`;
            }
            
            return stringValue;
          });
          
          csvContent += row.join(',') + '\n';
        });

        // Create and trigger download
        this.downloadCSV(csvContent, 'sales-data');
        
      } catch (error) {
        console.error('Error exporting CSV:', error);
        this.$bvToast.toast('Failed to export CSV: ' + error.message, {
          title: 'Export Error',
          variant: 'danger',
          solid: true
        });
      }
    },

    downloadCSV(csvContent, baseFilename) {
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      
      // Create filename with timestamp
      const timestamp = new Date().toISOString().slice(0, 19).replace(/[:]/g, '-');
      const filename = `${baseFilename}_${timestamp}.csv`;
      
      if (navigator.msSaveBlob) {
        // For IE/Edge
        navigator.msSaveBlob(blob, filename);
      } else {
        // For other browsers
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }
    },
    handleMenuChange(menuName) {
      this.activeMenu = menuName;
      // Add any navigation logic here
      console.log('Menu changed to:', menuName);
    },
    formatDate(date) {
        return DateTime.fromJSDate(date).toFormat('yyyy-MM-dd');
    },
    async testConnection() {
      try {
        const result = await apiHandler(() => Api.clickhouse.test.Get());
        this.connectionTested = true;
        if (result.success) {            
          this.connectionError = null;
          return true;
        } else {
          this.connectionError = result.error;
          return false;
        }
      } catch (error) {
        this.connectionTested = true;
        this.connectionError = true;
        return false;
      }
    },
    async fetchWestland(startDate, endDate) {
      console.log("Fetching Westland data...");

      try {
        const requestBody = {
          startDate: startDate + "T00:00:00.000Z",
          endDate: endDate + "T23:59:59.999Z",
          location : 10
        };

        const orderData = await apiHandler(() => Api.orders.Post(requestBody));
        const countData = await apiHandler(() => Api.orders[requestBody.startDate][requestBody.endDate][requestBody.location].Get());

        const orderTotal = orderData.reduce((s, d) => s + d.data.reduce((ds, i) => ds + +i.totalAmount, 0), 0);
        const orderCount = countData.reduce((sum, item) => sum + item.uniqueOrderCount, 0);
        console.log(orderCount);
        
        return {
          total: orderTotal, 
          count: orderCount
        };
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error fetching orders:", error);
      }
    },
    async fetchData() {
      this.loading = true;
      try {
        // 1. Ensure user is populated (AuthMixin usually provides this, or fetch it here)
        if (!this.user && this.getUser) {
          this.user = this.getUser(); // Common pattern in AuthMixins
        }
        console.log('User:', this.user);
        
        const data = await apiHandler(() => 
          Api.clickhouse.salesSnapshot.Get({
            startDate: this.filters.startDate,
            endDate: this.filters.endDate,
          })
        );

        const westTotal = await this.fetchWestland(this.filters.startDate, this.filters.endDate);

        // 2. Filter data for only users with store permissions
        let allowedData = data;

        if (this.user && this.user.id) {
          try {
            // Fetch the IDs of locations this user is allowed to see
            const rawLocations = await apiHandler(() => Api.user[this.user.id].locations.Get());
            const allowedIds = rawLocations.map(id => String(id));   
            console.log('Normalized Allowed IDs:', allowedIds);

            // Filter the main data set
            allowedData = data.filter(item => {
              if (this.user.level === 7) return true; // Admins get all locations

              const locNumber = this.getLocationNumber(item.Location);
              return locNumber ? allowedIds.includes(String(locNumber)) : false;
            });
            console.log('Allowed data after filtering:', allowedData);
          } 
          catch (error) {
            console.error('Error fetching user locations:', error);
            // Optional: clear data if permissions fail to load for security
            allowedData = []; 
          }
        }

        // 3. Process the filtered data (Add location numbers and Westland totals)
        this.tableData = allowedData.map(item => {
          const location = item.Location || '';
          const number = this.getLocationNumber(location);
          
          if(location.includes('Westland')){
            /* eslint-disable @typescript-eslint/camelcase */
            item.In_Store = Number(item.In_Store) + westTotal.total;
            item.Total_Sales = Number(item.Total_Sales) + westTotal.total;
            item.Order_Count = Number(item.Order_Count) + westTotal.count;
          }
          
          return {
            ...item,
            Location: number ? `#${number} ${location} ` : location
          };
        });

      } catch (error) {
        console.error('Error fetching data:', error);
        this.connectionError = error.message;
      } finally {
        this.loading = false;
      }
    }
  }
  };
  </script>
  
  <style scoped>

  .hide-cell {
    display: none !important;
    background-color: red;
  }
  /* Your existing styles remain the same */
  .main-container {
    /* min-height: 100vh; */
    padding: 0.5rem 0rem 0.5rem 0rem;
  }
  
  .main-content {
    /* background-color: red; */
    flex-grow: 1;
    min-width: 0;
    margin: 0 1em;
    padding: 0em;
  }

  .sales-info {
    margin-bottom: 0em;
  }
  
  .content-card {
    border-radius: 0.5em !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
    border: none;
    /* background-color: aquamarine; */
    width: 100%;
    margin: 0em;
    padding: 0em;
  }
  
  .touchpoint-dashboard {
    height: 100%;
    max-width: 1400px;
    padding: 0;
  }
  
  .dashboard-card {
    height: 100%;
    border-radius: inherit;
    /* background-color: violet; */
    width: 100%;
    margin: 0em;
    padding: 0em;
    padding: 1em 1em 0em 1em;
  
  }
  
  .card-body {
    padding: 0em;
  }
  
  .dashboard-header {
    padding-left: 0.5em;
    padding-right: 0.5em;
  }

  .sales-data {
    min-height: 18em;
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.2);
    position: relative;
    overflow: hidden;
    width: 100%;
  }

  .origin-group{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    /* padding-left: 1em;
    padding-right: 1em; */
    gap: 0.2em;
    margin: 0em;
  }

  .card-group{
    left: 0;
    justify-content: flex-start;
    width: 100%;
    padding: 0em;
    margin: 0em;
    display: flex;
    gap: 0.2em;
    flex-direction: row;
  }

  .origin-card {
    transition: all 0.3s ease;
    height: 3.3em;
    min-width: 10em;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 10px;
    transition: transform 0.2s, box-shadow 0.2s;
    /* margin-right: 0.2em; */
    }

  .origin-card:hover {
      /* transform: translateY(-5px); */
      box-shadow: 0 4px 8px rgba(0,0,0,0.2);
  }
  .origin-card.bg-primary {
      background-color: #3e187a;
      background-image: linear-gradient(316deg, #3e187a 0%, #994ecc 74%);

  }

  .origin-card.bg-success {
      background-color: #ffb347;
      background-image: linear-gradient(316deg, #F25424 0%, #ffc415 74%);
  }

  .origin-card.bg-info {
      background-color: #990000;
      background-image: linear-gradient(316deg, #990000 0%, #ff0000 74%);
  }

  .origin-card.bg-uber {
      background-color: #132227;
      background-image: linear-gradient(316deg, #132227 0%, #05C066 74%);
  }

  .origin-card.bg-grubhub-alt {
      background-color: #ff8000;
      background-image: linear-gradient(316deg, #1b1b5b 0%, #FF5500 74%);
  }
  .origin-card.bg-warning {
      background: rgb(0,127,255);
      background: linear-gradient(316deg, #2a52be 0%, #2391ff 74% );
  }

  .origin-card.bg-blank {
      background: rgb(66, 68, 71);
      background: linear-gradient(316deg, #434548 0%, #9ca2a8 74% );
  }
    
  .data-square {
    min-height: 14em;
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.2);
    position: relative;
    /* overflow: hidden; */
  }
  
  .data-square > div {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
  }
  
  .data-square .chart-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
  }

  /* New styles for data visualization */
  .top-store-card {
    border-left: 4px solid #28A745;
  }

  .worst-store-card {
    border-left: 4px solid #DC3545;
  }

  .store-icon {
    flex-shrink: 0;
  }

  .store-info {
    flex-grow: 1;
  }
  
  .legend-item {
    display: flex;
    align-items: center;
    margin-right: 15px;
  }
  
  .legend-color {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    margin-right: 8px;
    border: 1px solid rgba(0,0,0,0.2);
  }
  
  .legend-color.stars {
    background-color: rgba(255, 215, 0, 0.7);
  }
  
  .legend-color.plow-horses {
    background-color: rgba(144, 238, 144, 0.7);
  }
  
  .legend-color.puzzles {
    background-color: rgba(135, 206, 250, 0.7);
  }
  
  .legend-color.dogs {
    background-color: rgba(255, 99, 132, 0.7);
  }
  
  .legend-text {
    font-size: 12px;
    font-weight: 500;
  }
  
  .clearfix {
    clear: both;
  }
  
  .sales-table {
    margin-top: 0px;
    margin-bottom: 0;
    border: none !important;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.2);
  }
  
  .sales-table thead th {
    border: none !important;
    font-weight: 500;
  }
  
  .sales-table tbody td {
    border: none;
    padding: 14px 16px;
    vertical-align: middle;
    border-color: #f1f3f7;
  }
  
  .loading-indicator {
    display: inline-block;
    width: 20px;
    height: 20px;
    border: 3px solid rgba(255,255,255,.3);
    border-radius: 50%;
    border-top-color: #fff;
    animation: spin 1s ease-in-out infinite;
    margin-left: 10px;
  }
  
  .spinning-icon {
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
  
  .dashboard-icon {
    font-size: 1.5rem;
    margin-bottom: 1rem;
    opacity: 0.8;
  }
  
  .menu-icon {
    font-size: 1rem;
    opacity: 0.8;
  }
  .side-nav {
    float: left;
    width: 11em !important;
    flex-shrink: 0;
    height: fit-content;
  }
  
  .side-search{
    /* position: absolute; */
    bottom: 0px;
    left: 1em;
    right: 1em;
    box-shadow: 0 4px 8px rgba(0,0,0,0.2); 
    border-radius: 10px;
    border: none;
    padding: 0em;
  }
  .side-search > .my-search {
    border: 0em !important;
    height: 3em !important;
  }
  </style>